import { fetch, urlResolve } from '../../../../utils/fetch';

const getWholePath = (path) => {
  const prefix = '';
  return prefix + path;
};

/**
 * @desc undefined
 */
export function request(params, bodyParams, options = {}) {
  const fetchOption = Object.assign(
    {
      url: getWholePath('/oss/commonUploadFile'),
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
      },

      data: bodyParams,
    },
    options,
  );
  return fetch(fetchOption);
}
